import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { GET_KINSHIP } from "./actionType";

import { kinshipApiResponseSuccess, kinshipApiResponseError } from "./action";

import { getKinship as kinshipGet } from "../../helpers/backend_helper";
import { notifyError, notifySuccess } from "../../components/notify";

function* getKinship() {
  try {
    const response = yield call(kinshipGet);
    yield put(kinshipApiResponseSuccess(GET_KINSHIP, response));
  } catch (error) {
    yield put(kinshipApiResponseError(GET_KINSHIP, error));
  }
}

export function* watchGetKinship() {
  yield takeEvery(GET_KINSHIP, getKinship);
}

function* kinshipSaga() {
  yield all([fork(watchGetKinship)]);
}

export default kinshipSaga;
